import { Chain, ChainID, ChainSubType } from '@ankr.com/chains-list';

import { Tab } from 'modules/common/hooks/useTabs';
import { getChainSubtypeTabs } from 'modules/chains/utils/getChainSubtypeTabs';

import { ChainTypeTab } from '../../ChainTypeTab';

export interface ChainSubtypeTabsParams {
  chain: Chain;
  className?: string;
  onClick?: (id: ChainSubType) => void;
}

export const getChainSubTypeTabs = ({
  chain,
  className,
  onClick,
}: ChainSubtypeTabsParams) => {
  if (chain.id === ChainID.ZETACHAIN) {
    return getChainSubtypeTabs()
      .filter(({ id }) => id === ChainSubType.Athens3)
      .map<Tab<ChainSubType>>(({ id, title }) => ({
        id,
        title: (isSelected: boolean) => {
          const resolvedTitle =
            typeof title === 'function' ? title(false, false, id) : title;

          return (
            <ChainTypeTab
              className={className}
              isSelected={isSelected}
              label={resolvedTitle}
              onClick={() => onClick?.(id)}
            />
          );
        },
        isDisabled: false,
      }));
  }

  return [];
};
